import { FC } from 'react'

import { useAtomValue } from 'jotai'
import {
  Text,
  GreyGrey60,
  GreyGrey70,
  Primary12SemiBold,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { SidebarSection } from 'Cube/view/layouts/quote/QuoteEditorSidebar/widgets/SidebarSection'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { formatLastSeen } from './utils'
import { uniqueViewersAtom } from '../../atoms'
import { SignerLastSeenList } from './SignerLastSeenList'

const offlineListItemStyles = {
  name: { color: GreyGrey70 },
  caption: { color: GreyGrey60 }
}

export const LastSeen: FC = () => {
  const ctx = useCubeContext()

  const uniqueViewersData = useAtomValue(uniqueViewersAtom)

  const externalSigners = ctx.queries.rawData.data.quote.contacts
  const counterSigners = ctx.queries.rawData.data.quote.counterSigners

  const showEmptyState =
    externalSigners.length === 0 && counterSigners.length === 0

  const externalSignersLastSeen = formatLastSeen({
    signers: externalSigners,
    uniqueViewersData
  })

  const counterSignersLastSeen = formatLastSeen({
    signers: counterSigners,
    uniqueViewersData
  })

  return (
    <SidebarSection
      title="Last seen"
      data-testid="quote.sidebarSection.lastSeen"
    >
      <Flex gap="16px" flexDir="column">
        {showEmptyState && (
          <Text color={GreyGrey60} {...Primary13Regular}>
            All quote recipients will appear here.
          </Text>
        )}

        {externalSignersLastSeen.length > 0 && (
          <Flex gap="12px" flexDir="column">
            <Text {...Primary12SemiBold} color={GreyGrey60}>
              External signers
            </Text>

            <SignerLastSeenList>
              {externalSignersLastSeen.map(signer => (
                <SignerLastSeenList.Item
                  key={signer.email}
                  name={signer.name ?? signer.email}
                  email={signer.email}
                  status={signer.status}
                  caption={signer.caption}
                  styles={
                    signer.status === 'OFFLINE'
                      ? offlineListItemStyles
                      : undefined
                  }
                />
              ))}
            </SignerLastSeenList>
          </Flex>
        )}

        {counterSignersLastSeen.length > 0 && (
          <Flex gap="12px" flexDir="column">
            <Text {...Primary12SemiBold} color={GreyGrey60}>
              Countersigners
            </Text>

            <SignerLastSeenList>
              {counterSignersLastSeen.map(signer => (
                <SignerLastSeenList.Item
                  key={signer.email}
                  name={signer.name ?? signer.email}
                  email={signer.email}
                  status={signer.status}
                  caption={signer.caption}
                  styles={
                    signer.status === 'OFFLINE'
                      ? offlineListItemStyles
                      : undefined
                  }
                />
              ))}
            </SignerLastSeenList>
          </Flex>
        )}
      </Flex>
    </SidebarSection>
  )
}
